// extracted by mini-css-extract-plugin
export var h2 = "styles-module--h2--1258d";
export var h3 = "styles-module--h3--bc9ed";
export var heading = "styles-module--heading--c4061";
export var hl = "styles-module--hl--90232";
export var link = "styles-module--link--9a09e";
export var ol = "styles-module--ol--0520d";
export var spacing = "styles-module--spacing--341fe";
export var ul = "styles-module--ul--196b4";